import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ImageUploaderComponent } from 'src/app/image-uploader/image-uploader.component';

@Component({
  selector: 'app-setting-game-form',
  templateUrl: './setting-game-form.component.html',
  styleUrls: ['./setting-game-form.component.scss']
})
export class SettingGameFormComponent {

  public data: any = {status: 1, game_method: 'normal'}
  public providers:any = [];
  public provider_categories:any = []
  public categories:any = []
  public games:any = []
  public permission:any = {};
  private game_uuid:any;

  @ViewChild('f') f : NgForm
  @ViewChild("imageUploader", {static: true}) imageUploader : ImageUploaderComponent;

  constructor(private http: HttpService, private route: ActivatedRoute) { 
    const uuid: Observable<string> = this.route.params.pipe(map(p => p['uuid']));
    this.permission = this.http.getSelecetdCompanyDetail();

    uuid.subscribe(val => {
      if(val) {
        this.init(val)
        this.game_uuid = val;
      }

      this.initIntegration()
    })

    this.getGames();
    this.initGamesCategory();
  }

  async init(uuid) {
    this.data = await this.http.post('/admin/setting/game/get', {uuid});

    if(this.data.image) {
      this.imageUploader.files = [this.data.image]
    }

    if(!this.data.parent_id) {
      this.data.game_method = 'normal'
    } else {
      this.data.game_method = 'child'
    }

    this.checkIfCurrentProviderHaveCategory();

  }

  async getGames() {
    let games:any = await this.http.post("/admin/setting/game/get");
    this.games = games.filter((v:any) => {
      return !v.parent_id
    })
  }

  async initIntegration() {
    if(this.permission.game_integration) {
      this.providers = await this.http.post("/admin/integration", {status: 1});

      if(!this.data.integration_id) {
        this.data.integration_id = null;
      }


    }
  }

  checkIfCurrentProviderHaveCategory() {

    if(!this.data.integration_id) {
      return;
    }

    let y = this.providers.find((v:any) => {
      return v.id == this.data.integration_id
    })

    if(!y || !y.category) {
      this.provider_categories = []
      return;
    }

    this.provider_categories = y.category;
    
  }

  checkIfCurrentProviderHaveCategoryParent() {
    console.log(this.data, "aaaa")
    console.log(this.games, this.providers)

    // if(!this.data.integration_id) {
    //   return;
    // }


    let game = this.games.find((v:any) => {
      return v.id == this.data.parent_id
    })
console.log(game)

    let y = this.providers.find((v:any) => {
      return v.id == game.provider_category_id
    })
    
    console.log("_______hello", y)
    if(!y || !y.category) {
      this.provider_categories = []
      return;
    }

    this.provider_categories = y.category;
  }

  async initGamesCategory() {
    this.categories = await this.http.post("/admin/app/game/category/init");
  }

  async submit(stay = false) {
    await this.http.post('/admin/setting/game/update', this.data);

    if(stay) {
      return;
    }

    if (this.data.uuid) {
      this.http.navigate(['/lo',this.http.getStaticSelectedCompany(),'setting-game'])
      return;
    }
    
    await this.f.resetForm({status: 1});
  }

  async upload(v:any) {
    this.data.image = v[0];
  }

  removeImage() {

    if(!this.game_uuid) {
      return;
    }

    delete this.data.image;
    this.submit(true);
  }
}
